import { MetricContainer } from 'shared/issue_metrics/styled';

interface ErrorFallbackProps {
    error: Error;
    resetErrorBoundary: () => void;
}

export function ErrorFallback({ error, resetErrorBoundary }: ErrorFallbackProps) {
    return (
        <MetricContainer role="alert" aria-label="Error loading metrics" tabIndex={0}>
            <div className="flex-column align-center justify-center p-20">
                <span className="mb-10">Error loading metrics: {error.message}</span>
                <button onClick={resetErrorBoundary} className="btn btn-primary">
                    Try Again
                </button>
            </div>
        </MetricContainer>
    );
}
